

























import { Component, Vue, Prop } from "vue-property-decorator";
import { WowClass } from "./../types/WowClass";
import prismicDOM from 'prismic-dom';

@Component({})
export default class ClassCard extends Vue {
  @Prop(Object) wowClass!: WowClass;

   get desc() {
    return prismicDOM.RichText.asHtml(this.wowClass.short_description);
  }
}
